import * as React from 'react';

import { useQuery } from '@apollo/client';

import filterExistsOrDefault from 'bundles/enterprise-legacy-learner-home/utils/filterExistsOrDefault';
import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import { MAX_NUMBER_OF_SKILLSETS } from 'bundles/page-config-common/constants/enterpriseConstants';
import EnterpriseSkillSetsContext from 'bundles/page-config-common/contexts/enterprise/EnterpriseSkillSetsContext';
import ObjectiveListQuery from 'bundles/page-config-common/queries/ObjectiveListQuery.graphql';
import type {
  ObjectiveListQueryQuery,
  ObjectiveListQueryQueryVariables,
} from 'bundles/page-config-common/queries/__generated__/ObjectiveListQuery';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

/**
 * @description This provider is used to fetch the program's skillsets
 */
export const EnterpriseSkillSetsProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const program = useProgram();
  const programId = program?.id;

  const enableEnterpriseHomeRefresh = GrowthDiscoveryEpicClient.preview('enableEnterpriseHomeRefresh');

  const { data, loading, error } = useQuery<ObjectiveListQueryQuery, ObjectiveListQueryQueryVariables>(
    ObjectiveListQuery,
    {
      skip: !programId || !enableEnterpriseHomeRefresh,
      variables: {
        programId: programId!,
        limit: MAX_NUMBER_OF_SKILLSETS,
      },
      context: { clientName: 'gatewayGql' },
      errorPolicy: 'all',
      ssr: false,
    }
  );
  const skillsets = filterExistsOrDefault(
    data?.NaptimeQueries?.EnterpriseTargetSkillProfileSummariesV1Resource?.byProgram?.elements
  );
  return (
    <EnterpriseSkillSetsContext.Provider
      value={{
        skillsets,
        hasError: !!error,
        skillsetsLoading: loading,
      }}
    >
      {children}
    </EnterpriseSkillSetsContext.Provider>
  );
};

export default EnterpriseSkillSetsProvider;
